<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/guanhuai',title:'用户交互'},{title:'项目管理'}]"/>-->
      <Breadtabsheader/>
        <div style="margin:20px">
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                        <div class="h-thirdColumn w-newColumn">
                            <el-form-item label="项目">
                                <el-input v-model="q.projectCode" placeholder="请输入项目名称或编码"></el-input>
                            </el-form-item>
                            <el-form-item label="状态" prop="billCode">
                                <el-select v-model="q.status" :clearable="true"
                                           placeholder="请选择">
                                    <el-option label="正常" value="1"></el-option>
                                    <el-option label="禁用" value="0"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="创建日期" class="timeselect" style="width: 50%;">
                                <el-date-picker
                                        placeholder="请选择"
                                        v-model="q.startDate"
                                        clearable
                                        type="date"
                                        value-format="yyyy-MM-dd" >
                                </el-date-picker>
                                <span class="w-time-to">至</span>
                                <el-date-picker
                                        placeholder="请选择"
                                        v-model="q.endDate"
                                        clearable
                                        type="date"
                                        value-format="yyyy-MM-dd" >
                                </el-date-picker>
                            </el-form-item>
                        </div>
                    </el-form>
                    <div class="l-screenBox">
                        <div class="l-retrieval">
                            <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
<!--                            <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" @click="addEditDialog('','add')">新增</el-button>-->
                        </div>
                    </div>
                </div>
            </div>
            <div class="h-table h-mrt30">
                <el-table
                        @selection-change="handleSelectionChange"
                        :data="tableData"
                        :span-method="objectSpanMethod"
                        stripe
                        border
                        @header-click="headerClick"
                        style="width: 100%"
                >
                    <el-table-column
                            type="selection"
                            width="40"
                            :label="all"
                            @header-click="headerClick"
                    >
                    </el-table-column>
                    <el-table-column
                            type="index"
                            width="40"
                            label="#">
                    </el-table-column>
                    <el-table-column
                            prop="cucode"
                            label="创建人工号"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="cuname"
                            label="创建人姓名"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="projectCode"
                            label="项目编号"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="projectName"
                            label="项目名称"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="status"
                            label="状态"
                    >
                        <template slot-scope="scope">
                            <span v-if="scope.row.status == 1">正常</span>
                            <span v-if="scope.row.status == 0">禁用</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="cdate"
                            label="创建时间"
                            width="160">
                    </el-table-column>
                    <el-table-column
                            label="操作"
                            width="140"
                            fixed="right"
                    >
                        <template slot-scope="scope">
                            <div style="display: flex;align-items: center;justify-content: center;">
<!--                                <el-button-->
<!--                                        size="small" class="h-tableLink h-btn"-->
<!--                                        style="margin-left: 0;"-->
<!--                                        @click="del(scope.row.id)">-->
<!--                                    删除-->
<!--                                </el-button>-->
                                <el-button
                                        size="small" class="h-tableLink h-btn"
                                        style="margin-left: 0;"
                                        @click="ban(scope.row.id)">
                                    禁用
                                </el-button>
                            </div>
                            <!-- <div class="l-operationBox">
                                <span class="l-operationlist br-operation-look" title="查看" @click="goDetails(scope.row)"></span>
                                <span class="l-operationlist br-operation-fh" title="安排发货" @click="send(scope.row.sapCode)"></span>
                            </div> -->
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="h-tableB h-mrt30">
                <div class="h-tableBL">
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                               @click="exportRqExcel()">批量导出
                    </el-button>
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export"
                               @click="uploaddownexcelflagbtn">批量导入
                    </el-button>
                    <uploaddownexcel
                            :visible.sync="uploaddownexcelflag"
                            v-if="uploaddownexcelflag"
                            clsname="userDailyTargetProjectExcel"
                            :startrow="2" @callback="uploadExcelFilecallback"/>
                </div>
                <div class="h-pagination2">
                    <pagination :page="q" @query="query" style="padding-top: 0.1rem"/>
                </div>
                <!--                        </div>-->
                <!--                    </div>-->
                <!--                </div>-->
            </div>
        </div>
    </div>
</template>

<script>
    import ss from '../../../api/SystemService'
    import updownfile from '../../../utils/updownfile'
    import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'

    export default {
        components: {
            uploaddownexcel,
        },
        data() {
            return {
                q: {
                    status:null,
                    projectCode:'',
                    startDate:'',
                    endDate:'',
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                tableData: [],
                showOrhide1: false,
                uploaddownexcelflag: false,
                multipleSelection:[],
            }
        },
        methods: {
            resetData() {
                this.q.status = '';
                this.q.projectCode = '';
                this.q.startDate = '';
                this.q.endDate = '';
            },
            //检索
            handleFilter(query) {
                this.query();
            },
            //表格
            query() {
                ss.targetProject.selectProject(this.q).then(rd => {
                    this.q.total = rd.msg.total;
                    this.tableData = rd.msg.records;
                    this.tableLoadStatus = true;
                });
            },
            del(id){
                this.$msg.confirm("确认删除?", () => {
                    ss.targetProject.deleteId(id).then(rd => {
                        this.query();
                    });
                })
            },
            ban(id){
                this.$msg.confirm("确认禁用?", () => {
                    ss.targetProject.banProject(id).then(rd => {
                        this.query();
                    });
                })
            },
            showzhezhao() {
                ss.salesList.toshow(this.toshow1).then(rd => {
                    if (rd == false) {
                        this.showOrhide1 = false;
                    } else {
                        this.showOrhide1 = true;
                    }
                })
            },
            uploadExcelFilecallback(rd) {
                this.query();
                this.$msg.msgs(rd.msg);
            },
            //导入Excel
            uploaddownexcelflagbtn() {
                this.uploaddownexcelflag = true;
            },
            //表格
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
        },
        created() {
            this.showzhezhao();
            this.query();
        },
    }
</script>

<style scoped>

</style>